export const optionsWithVisibilitySet = options =>
  options.map(option => ({
    ...option,
    isFiltered: false,
  }));

export const optionsFiltered = (options, term) => {
  const searchTerm = term.toLowerCase();
  return options.map((option) => {
    const label = option.label.toLowerCase();
    return {
      ...option,
      isFiltered: !option.isHeader && label.includes(searchTerm),
    };
  });
};

export const selectFirstFilteredItem = options => options.find(option => option.isFiltered);

export const selectFirstItem = options => options[0];

export const firstItem = (hasFilter, options) => {
  if (hasFilter) {
    return selectFirstFilteredItem(options);
  }
  return selectFirstItem(options);
};
